<div class="wrapper">
  <div class="columns">
    @for (column of columns(); track $index) {
      @if (!isIntegrationsColumn($index)) {
        <div
          class="column"
          [style.width.px]="widths()[$index]"
        >
          {{ column }}
        </div>
      }
      @if (isIntegrationsColumn($index)) {
        <div
          class="column integrations"
          [style.width.px]="widths()[$index]"
        >
          <app-update-input-number
            #updateInputNumberComponent
            [hidden]="!isEditState()"
            [startValue]="+column.split('/')[0]"
            [rolesWhichCanEdit]="['ROLE_ADMIN', 'ROLE_REVIEWER']"
            [onlyReadonlyField]="!isAssignedManager()"
            (saveValue)="handleSaveIntegrations($event)"
            (editState)="handleEditStateChange($event)"
          />
          <span
            class="edit-trigger"
            [class]="{
              'hidden': isEditState(),
              'readonly': !userCanEdit()
            }"
            (click)="handleValueClick()"
          >
           {{ column }}
          </span>
        </div>
      }
    }
  </div>
</div>
